import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
// const STUDENT = 'student'
const CREATOR = 'creator'
const TEXT = 'text'
const GROUPS = 'groups'
const GROUP_COURSES = 'group_courses'
const IS_STAFF_ONLY = 'is_staff_only'
const IS_BROADCAST = 'is_broadcast'
const IS_EDITABLE = 'is_editable'
const IS_DELETABLE = 'is_deletable'

/**
 * Form model
 */
const formModel = () => {
  return {
    [CREATOR]: {
      label: `${t('common.creator')}`,
      name: CREATOR,
    },
    [TEXT]: {
      label: `${t('common.text')}`,
      name: TEXT,
      required: true,
    },
    [GROUPS]: {
      label: `${t('common.groups')}`,
      name: GROUPS,
    },
    [GROUP_COURSES]: {
      label: `${t('common.group-courses')}`,
      name: GROUP_COURSES,
    },
    [IS_STAFF_ONLY]: {
      label: `${t('common.is-staff-only')}`,
      name: IS_STAFF_ONLY,
    },
    [IS_BROADCAST]: {
      label: `${t('common.is-broadcast')}`,
      name: IS_BROADCAST,
    },
    [IS_EDITABLE]: {
      label: `${t('common.is-broadcast')}`,
      name: IS_BROADCAST,
    },
    [IS_DELETABLE]: {
      label: `${t('common.is-broadcast')}`,
      name: IS_BROADCAST,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [CREATOR]: '',
  [TEXT]: '',
  [GROUPS]: [],
  [GROUP_COURSES]: [],
  [IS_STAFF_ONLY]: true,
  [IS_BROADCAST]: false,
  [IS_EDITABLE]: false,
  [IS_DELETABLE]: false,
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [GROUPS]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('required-error-message')}`),
      })
      .nullable(),
    [TEXT]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [IS_STAFF_ONLY]: yup.boolean(),
    [IS_BROADCAST]: yup.boolean(),
  })

export default formModel
